export const statusTextToIndex = {
  "全部": -1,
  "待配货": 20,
  "配货中": 21,
  "已配货": 30,
  "已取消": 40
};
const keyReverseValue = (values) => Object.keys(values).reduce((pre, next) => ({ ...pre, [values[next]]: next }), {});
export const IndexToStatusText = keyReverseValue(statusTextToIndex);
export const orderTypeTextToIndex = {
  "全部": 0,
  "建议补货": 1,
  "手工补货": 2,
  "CPM销售补货": 3,
  "仓库补单": 4
};
export const IndexToOrderTypeText = keyReverseValue(orderTypeTextToIndex);

export const showNumber = 3;